import apiService from "../../../services/api";
import { FinanceData, TimeRange } from "../model/finance_model";

export const FinanceApi = {
  getDashboard: async (timeRange: TimeRange): Promise<FinanceData> => {
    const response = await apiService.get("/super-admin/finance/dashboard", {
      time_range: timeRange,
    });
    const data = response.data as FinanceData;

    if (data?.success === false) {
      throw new Error("Failed to load financial data");
    }

    return data;
  },
};
